export default __webpack_public_path__ + "static/media/single-user.9e33544b.svg";